import generateLogger from '@travel/logger';

type CheckIsNumberProps = {
  value: number | string;
  errorHandler: {
    dispatch: any;
    payloadAction: any;
  };
};

export const checkIsNumber = (props: CheckIsNumberProps) => {
  const logger = generateLogger();
  const { errorHandler, value } = props;
  const { dispatch, payloadAction } = errorHandler;

  // Check if value is a number
  if (isNaN(Number(value))) {
    const error = new Error(
      `Invalid type: current type is ${typeof value}, expected type is number`,
    );
    logger.error(error);
    dispatch(payloadAction(false));
    throw error;
  }
};
